module.exports = __webpack_public_path__ + "static/media/letter2.8add1d79.jpg";